// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Decimal data type bit width enum.
 */
export enum DecimalBitWidthEnum {
  _128 = 0,
  _256 = 1
}
